module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAYCAYAAADtaU2/AAAA4ElEQVRIieXVvY0CMRCG4fezEGRHCiRsEVwDlEELrsctUAVUQgDBIpFx5KAhWf5WRiDh9Z7EF9mz1jzacWAByNsI2JInQwvauWpTZEKvVmtwJwLPAZ8YC8DsFbyyoL+Uqryt7rYFxEe9SYlGerYMy5uAcXYYGALdqngCygbgsuoN0JO3geNxzKUFHVOrVc/7Hyrq8CY1+qR3Vnj9L2DJ2xKYNgjGsnDAJDMK8OuAnxbgfqdWKIBDg+D+sqjDh08fCHmzWN2CJH/75GKHcqQ1uD7qj2NBeuecnt1J0/m+Oz4Dbkc6adPbQHoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shebei.png
// module id = qp+r
// module chunks = 1